import React from 'react';
import { PropTypes } from 'prop-types';

const ListOfPages = ({ numberOfPages, currentPage, setCurrentPage }) => {
  // This creates an array with numberOfPages length
  const createList = () => {
    if (numberOfPages > 15 && (numberOfPages - currentPage) < 8) return Array.from({ length: 12 }, (_, index) => index + numberOfPages - 11);
    if (numberOfPages > 15 && currentPage > 8) return Array.from({ length: 9 }, (_, index) => index + currentPage - 4);
    if (numberOfPages > 15 && currentPage < 9) return Array.from({ length: 12 }, (_, index) => index + 1);
    return Array.from({ length: numberOfPages }, (_, index) => index + 1);
  };
  const listElements = createList();
  return (
    <div className="flex px-10">
      {numberOfPages > 15 && currentPage > 8
      && (
      <div className="flex">
        <button
          type="button"
          key="1"
          onClick={() => setCurrentPage(1)}
          className={` w-10 h-10 flex items-center justify-center ${currentPage === 1 && 'rounded-md border-2 border-vamos-black'}`}
        >
          1
        </button>
        <button
          type="button"
          key="2"
          onClick={() => setCurrentPage(2)}
          className={` w-10 h-10 flex items-center justify-center ${currentPage === 2 && 'rounded-md border-2 border-vamos-black'}`}
        >2
        </button>
      </div>
      )}
      {numberOfPages > 15 && currentPage > 8 && <div key="spaceL" className="w-10 h-10 flex items-center justify-center">...</div>}
      {listElements.map((element) => (
        <button
          type="button"
          key={element}
          onClick={() => setCurrentPage(element)}
          className={` w-10 h-10 flex items-center justify-center ${currentPage === element && 'rounded-md border-2 border-vamos-black'}`}
        >{element}
        </button>
      ))}
      {numberOfPages > 15 && currentPage < (numberOfPages - 7) && <div key="spaceR" className="w-10 h-10 flex items-center justify-center">...</div>}
      {numberOfPages > 15 && currentPage < (numberOfPages - 7)
      && (
      <div className="flex">
        <button
          type="button"
          key={numberOfPages - 1}
          onClick={() => setCurrentPage(numberOfPages - 1)}
          className={` w-10 h-10 flex items-center justify-center ${currentPage === numberOfPages - 1 && 'rounded-md border-2 border-vamos-black'}`}
        >{numberOfPages - 1}
        </button>
        <button
          type="button"
          key={numberOfPages}
          onClick={() => setCurrentPage(numberOfPages)}
          className={` w-10 h-10 flex items-center justify-center ${currentPage === numberOfPages && 'rounded-md border-2 border-vamos-black'}`}
        >{numberOfPages}
        </button>
      </div>
      )}
    </div>
  );
};

export default ListOfPages;

ListOfPages.propTypes = {
  numberOfPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
};

